function findById<T extends BaseRequest>(requests: T[], id: string | undefined): T | undefined {
  return requests.find(el => el.requestId === id);
}

export default findById;
